import { Link, Outlet, useLocation } from 'react-router-dom';

/**
 * The frame for someone outside the full app: a VISITOR browsing the courses
 * (when the tenant shows them publicly), or a MEMBER who has not set up their
 * coaching yet. The tab bar's coaching screens would only bounce a member to
 * the onboarding, so this is the brand, the two areas a member can use without
 * it (Shop and Learn), and one way onward: logging in, or starting the coaching.
 */
export function LearnFrame({
  member = false,
  area = 'learn',
}: {
  member?: boolean;
  area?: 'learn' | 'shop';
}) {
  const { pathname, search } = useLocation();
  const here = encodeURIComponent(`${pathname}${search}`);
  const areaLink = (key: 'shop' | 'learn', label: string) => (
    <Link
      to={`/${key}`}
      aria-current={area === key ? 'page' : undefined}
      className={['eyebrow hover:text-ink', area === key ? 'text-ink' : ''].join(' ')}
    >
      {label}
    </Link>
  );
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <header className="sticky top-0 z-30 border-b border-border bg-background">
        <div className="mx-auto flex max-w-[63rem] items-center justify-between gap-4 px-5 py-3">
          <Link
            to={member ? `/${area}` : '/welcome'}
            className="font-display text-lg font-semibold tracking-tight text-ink"
          >
            Miracles Protocol
          </Link>
          {member ? (
            <nav aria-label="Member areas" className="flex items-center gap-4">
              {areaLink('shop', 'Shop')}
              {areaLink('learn', 'Learn')}
              <Link to="/home" className="eyebrow hover:text-ink">
                Start your coaching
              </Link>
            </nav>
          ) : (
            <Link to={`/login?next=${here}`} className="eyebrow hover:text-ink">
              Log in
            </Link>
          )}
        </div>
      </header>
      <main className="flex-1 pb-16">
        <div className="mx-auto w-full max-w-[63rem] lg:px-9 lg:pt-11">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
